'use strict';
const angular = require('angular');

export class webaccessCreateComponent {
  /*@ngInject*/
  constructor(SettingsService, Auth) {
    this.SettingsService = SettingsService;
    this.Auth = Auth;

    this.model = {
      contact: null,
      email: "",
      activationType: "invitation",
      additionalRoles: ["evoting-user"]
    };
  }

  $onInit = function () {
    this.SettingsService.getByName({name: 'config.platform'}, appSettings => {
      this.config = this.resolve.config;

      console.log(this.config);

      this.contacts = this.config.contacts.map(c => {
        return {
          value: c._id,
          name: this.getComposedName(c)
        }
      });

      if (this.contacts && this.contacts.length) {
        this.model.contact = this.contacts[0].value;
      }

      this.model.email = this.config.email;

      this.model.associationOrGroupCode = appSettings.data.clientCode;
      this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};

      console.log(this.model);
    });


  };

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  ok() {
    this.close({$value: this.model});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.webaccessCreate', [])
  .component('webaccessCreate', {
    template: require('./webaccess-create.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: webaccessCreateComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/webaccess-create/webaccess-create.component.js